import { Action, createReducer, on } from '@ngrx/store';
import { TimecardState } from './timecard.state';
import { updateTimecardComplete } from './timecard.actions';

export const timecardFeatureKey = 'timecard';

export const initialState: TimecardState = {
    signalRLoading: undefined,
    error: undefined,
    updatedTimecard: { id: null }
};

const TimecardReducer = createReducer(
    initialState,

    on(
        updateTimecardComplete,
        (state, action): TimecardState => ({
            ...state,
            updatedTimecard: { id: action.timecardId }
        })
    )
);

export function timecardReducer(state: TimecardState | undefined, action: Action) {
    return TimecardReducer(state, action);
}
